/**
 * The order tables appear on the billing and CaptainPAD boards: the position
 * saved in Settings → Tables first, the table number after (owner, 2026-10-25:
 * "I tried reordering the tables, it didn't work" — the boards sorted by number
 * only). A board cached before positions were sent has none, and falls back to
 * the number, as before.
 */
export const byBoardOrder = (a, b) => {
  const sa = a?.sort_order;
  const sb = b?.sort_order;
  if (Number.isFinite(sa) && Number.isFinite(sb) && sa !== sb) return sa - sb;
  return (a?.number ?? 0) - (b?.number ?? 0);
};

/**
 * Areas keep the order the server sends them in (each area's place is where its
 * first table sits in Settings → Tables). The offline cache keys areas by name,
 * and IndexedDB hands rows back in key order — so the boards showed areas
 * alphabetically, whatever the arrangement (owner, 2026-10-25: "Terrace after
 * Garden is not reflected"). Stamp the position on the way in, sort on the way out.
 */
export const withServerPosition = rows => (rows || []).map((row, position) => ({ ...row, position }));

export const byServerPosition = (a, b) => {
  const pa = Number.isFinite(a?.position) ? a.position : Number.MAX_SAFE_INTEGER;
  const pb = Number.isFinite(b?.position) ? b.position : Number.MAX_SAFE_INTEGER;
  return pa - pb;
};

/**
 * A table's tile on the boards spans 1–2 columns and rows (floor designer resize,
 * owner 2026-10-25). Pending-bill cards and older cached boards are 1×1.
 */
const spanOf = v => Math.max(1, Math.min(2, Number(v) || 1));
export const tileSpan = table =>
  table?.isPendingBillCard ? {} : { gridColumn: `span ${spanOf(table?.width)}`, gridRow: `span ${spanOf(table?.height)}` };
// Only a 1x1 tile is square: it sets the row height. A spanned tile fills the cells
// it covers (an aspect ratio would ignore the gaps and stretch its row).
export const tileAspect = table =>
  table?.isPendingBillCard || (spanOf(table?.width) === 1 && spanOf(table?.height) === 1) ? "1 / 1" : "auto";
